import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "decimals-static"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["visualIndent"];
const _hoisted_4 = {
    key: 0,
    class: "mnemonic"
};
const _hoisted_5 = {
    key: 1,
    class: "no-currency"
};
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { key: 2 };
import UTooltip from "./UTooltip.vue";
import BigNumber from "bignumber.js";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { formatDecimalStatic } from "@/help/decimalStatic";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UDecimal',
    props: {
        value: { default: "" },
        decimals: { default: 0 },
        indent: { default: 2 },
        addition: { default: "" },
        showAddition: { type: Boolean, default: true },
        visualIndent: { type: Boolean, default: true },
        noneIfEmpty: { type: Boolean, default: false },
        zeroIfLittle: { type: Boolean, default: false },
        smartIndent: { type: Boolean, default: false },
        trimZeros: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const windowWidth = ref(window.innerWidth);
        const showValue = computed(() => {
            const value = props.value ? props.value.toString().replace(",", ".") : "0";
            const numericValue = new BigNumber(value);
            if (props.noneIfEmpty && numericValue.isZero()) {
                return false;
            }
            return !numericValue.isNaN();
        });
        const displayValue = computed(() => {
            return formatDecimalStatic({
                value: props.value,
                decimal: props.decimals,
                indent: props.indent,
                smartIndent: props.smartIndent,
                trimZeros: props.trimZeros
            });
        });
        const currency = computed(() => {
            return props.addition === "-" ? null : props.addition;
        });
        const handleResize = () => {
            windowWidth.value = window.innerWidth;
        };
        onMounted(() => {
            window.addEventListener("resize", handleResize);
        });
        onUnmounted(() => {
            window.removeEventListener("resize", handleResize);
        });
        return (_ctx, _cache) => {
            return (showValue.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                    (__props.zeroIfLittle && Number(displayValue.value) < 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " ~0 "))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            visualIndent: __props.visualIndent,
                            class: "value"
                        }, _toDisplayString(displayValue.value), 9, _hoisted_3)),
                    (__props.showAddition)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (currency.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(currency.value), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                    _cache[0] || (_cache[0] = _createTextVNode(" NTN ", -1)),
                                    _createVNode(UTooltip, { tooltip: "NO TOKEN NAME" })
                                ]))
                        ], 64))
                        : _createCommentVNode("", true)
                ]))
                : (__props.noneIfEmpty)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "None"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"));
        };
    }
});
